import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule, AngularFirestore } from 'angularfire2/firestore';

import { environment } from '../environments/environment';

//import { NgModule} from '@angular/core';
import { APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule, Routes } from '@angular/router';
import { Router } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
//import { MDBBootstrapModule } from 'angular-bootstrap-md';

import { setTableNamePrefix,setConfig } from "../../models/data.model";

import { DadosModule }  from "../../models/dados.module";
import { ServicesModule } from '../../comum/services/services.module';
import { MaterialModule } from '../../comum/material.module';
import { ControlsModule } from '../../comum/controls/controls.module';

import { AppComponent } from './app.component';
import { HeaderComponent } from './nav/header/header.component';
import { SidenavListComponent } from './nav/sidenav-list/sidenav-list.component';

import { AppControlsModule }  from './controls/app.controls.module';
import { ViewsModule } from './views/views.module';
import { FechamentoModule} from './fechamento/fechamento.module';
import { LOCALE_ID } from '@angular/core';

import {DirectivesModule} from './directives/directives.module';
import { SidenavChatComponent } from './nav/sidenav-chat/sidenav-chat.component';
import { ChatsModule } from '../../chats/chats.module';
import { AngularFireDatabase } from 'angularfire2/database';
import { CustomMaterialModule }  from '../../comum/custom-material.module';
import { MensagemDialog } from './views/mensagem/mensagem';
import { UsersService } from '../../models/usuarios.service';
import { AngularFireAuth, AngularFireAuthModule } from 'angularfire2/auth';
import { CustomDialogModule } from '../../comum/custom-dialog.module';
import { HttpModule } from '@angular/http';

setConfig(environment);


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidenavListComponent,
    SidenavChatComponent,
    MensagemDialog,
  ],
  entryComponents:[
    MensagemDialog,
  ],
  imports: [
    DadosModule.forRoot({prefix: environment.db_prefix }),
    FormsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
         
    AngularFireModule.initializeApp(environment.firebase),

    AngularFirestoreModule,//.enablePersistence() ,  // off-line
    AngularFireAuthModule,
    BrowserModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    BrowserModule,
    ServicesModule,
    MaterialModule,
    CustomMaterialModule,
    ControlsModule,
    AppControlsModule,
    ViewsModule,
    FechamentoModule,
    RouterModule,
    AppRoutingModule,
    DirectivesModule,
    ChatsModule,
    CustomDialogModule,
  ],
  schemas:[ NO_ERRORS_SCHEMA],
  exports:[
    MaterialModule,
    AppControlsModule,
    ViewsModule,
    FechamentoModule,
    FlexLayoutModule,
    DirectivesModule,
  ],
  providers: [  UsersService,  AngularFireDatabase, AngularFireAuth,
    HttpModule,
    //{provide: LOCALE_ID, useValue: 'pt-BR'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor( private db: AngularFirestore ){
    db.firestore.settings({timestampsInSnapshots:true});
    db.firestore.enablePersistence();
    // DadosModule.forRoot({prefix: environment.db_prefix });
   //  AngularFireModule.initializeApp(environment.firebase);
   //  AngularFirestoreModule.enablePersistence() ;  // off-line
 
  }
 }
